<template>
  <v-container
    v-if="allFinalExamsCalendars2 && examStudents && renderComponent"
    style="background-color: white"
    fluid
  >
    <span v-if="allFinalExamsCalendars2">
      <span class="blue--text">Шалгалтын тоо</span>:
      {{ allFinalExamsCalendars2.length }}</span
    >, {{ $attrs.selectedClassGroup.STUDENT_GROUP_NAME }}

    <v-row justify="space-around" align="center" no-gutters class="my-5">
      <v-col class="d-flex align-center" cols="auto">
        <v-avatar size="12" color="blue" class="mr-2"></v-avatar>
        <span class="text-grey">Бүртгэсэн</span>
      </v-col>

      <v-col class="d-flex align-center" cols="auto">
        <v-avatar size="12" color="purple" class="mr-2"></v-avatar>
        <span class="text-grey">Цуцлагдсан</span>
      </v-col>

      <v-col class="d-flex align-center" cols="auto">
        <v-avatar size="12" color="orange" class="mr-2"></v-avatar>
        <span class="text-grey">Хянагдаж байгаа</span>
      </v-col>

      <v-col class="d-flex align-center" cols="auto">
        <v-avatar size="12" color="green" class="mr-2"></v-avatar>
        <span class="text-grey">Батлагдсан</span>
      </v-col>
    </v-row>

    <v-simple-table>
      <thead>
        <tr>
          <th class="text-left" style="width: 1%">№.</th>
          <th class="text-left">Хичээл</th>
          <th
            v-for="(exam, examIndex) in allFinalExamsCalendars2"
            :key="examIndex"
          >
            {{ exam.name2 }}
          </th>
        </tr>
      </thead>
      <tbody v-if="$attrs.classStudents">
        <tr v-for="(student, index) in $attrs.classStudents" :key="index">
          <td>{{ student.index }}</td>
          <td style="width: 14%">
            {{ student.name }} /{{ student.REGISTER }}/
          </td>
          <td
            v-for="(exam, examIndex) in allFinalExamsCalendars2"
            :key="examIndex"
            :class="{
              'blue--text': _getScore(exam, student, true) == null,
              'purple--text': _getScore(exam, student, true) == 'REJECTED',
              'orange--text':
                _getScore(exam, student, true) == 'CHECKED' ||
                _getScore(exam, student, true) == 'PENDING',
              'green--text': _getScore(exam, student, true) == 'APPROVED',
            }"
          >
            {{ _getScore(exam, student, false) }}
          </td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import { sync } from "vuex-pathify";
export default {
  data() {
    return {
      renderComponent: true,
      allFinalExamsCalendars2: null,
      examStudents: null,
      loading: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    ...sync("*"),
  },
  methods: {
    _getScore(exam, student, isColor) {
      if (this.examStudents) {
        var sss = this.examStudents.find(
          (ss) =>
            String(ss.PERSON_ID) == String(student.PERSON_ID) &&
            ss.exams &&
            ss.exams[exam.TEST_COMPONENT_SESSION_ID]
        );
      }
      if (isColor) {
        return sss && sss.exams && sss.exams[exam.TEST_COMPONENT_SESSION_ID]
          ? sss.exams[exam.TEST_COMPONENT_SESSION_ID].APPROVAL_STATUS
          : null;
      } else {
        return sss &&
          sss.exams &&
          sss.exams[exam.TEST_COMPONENT_SESSION_ID] &&
          sss.exams[exam.TEST_COMPONENT_SESSION_ID].SCORE != null
          ? sss.exams[exam.TEST_COMPONENT_SESSION_ID].SCORE +
              " " +
              this.calScoreLevel(
                sss.exams[exam.TEST_COMPONENT_SESSION_ID].SCORE
              )
          : null;
      }
    },
    calScoreLevel(tmpScore) {
      var gradeStr;
      // var gradePoints;
      if (tmpScore >= 90) {
        // gradePoints = 8;
        gradeStr = "VIII";
      } else if (tmpScore >= 80) {
        // gradePoints = 7;
        gradeStr = "VII";
      } else if (tmpScore >= 70) {
        // gradePoints = 6;
        gradeStr = "VI";
      } else if (tmpScore >= 60) {
        // gradePoints = 5;
        gradeStr = "V";
      } else if (tmpScore >= 50) {
        // gradePoints = 4;
        gradeStr = "IV";
      } else if (tmpScore >= 40) {
        // gradePoints = 3;
        gradeStr = "III";
      } else if (tmpScore >= 30) {
        // gradePoints = 2;
        gradeStr = "II";
      } else if (tmpScore >= 0 && typeof tmpScore == "number") {
        // gradePoints = 1;
        gradeStr = "I";
      } else if (
        tmpScore == null ||
        tmpScore == undefined ||
        typeof tmpScore != "number"
      ) {
        // gradePoints = null;
        gradeStr = null;
      }
      return gradeStr;
      // if (
      //   item.score > 0 &&
      //   (this.$attrs.lesson.courseInfo.GRADING_SCHEME_ID == 13 ||
      //     this.$attrs.lesson.courseInfo.GRADING_SCHEME_ID == 14)
      // ) {
      //   item.scoreLevelString = "Тооцов";
      //   item.score = 100;
      //   item.scoreFinal = 100;
      //   item.scoreLevelNumber = 8;
      // } else if (
      //   item.score == 0 &&
      //   (this.$attrs.lesson.courseInfo.GRADING_SCHEME_ID == 13 ||
      //     this.$attrs.lesson.courseInfo.GRADING_SCHEME_ID == 14)
      // ) {
      //   item.scoreLevelString = "Тооцоогүй";
      //   item.score = 0;
      //   item.scoreFinal = 0;
      //   item.scoreLevelNumber = 1;
      // }
    },
    async forceRerender() {
      this.renderComponent = false;
      await this.$nextTick();
      this.renderComponent = true;
    },
  },
  created() {
    var examRef = this.userData.school.ref
      .collection("stateExams-2025")
      .doc(
        "classGroupId-" +
          String(this.$attrs.selectedClassGroup.STUDENT_GROUP_ID)
      )
      .collection("exams");
    examRef.get().then((docs) => {
      this.allFinalExamsCalendars2 = [];
      docs.forEach((doc) => {
        let exam = doc.data();
        exam.id = doc.id;
        exam.ref = doc.ref;
        exam.name2 = exam.EXAM_NAME.replace(
          this.$attrs.selectedClassGroup["ACADEMIC_LEVEL"] + "-р ангийн",
          ""
        );

        this.allFinalExamsCalendars2.push(exam);
        this.forceRerender();
      });
      console.log(this.examStudents, this.allFinalExamsCalendars2);

      this.loading = false;
    });
    this.userData.school.ref
      .collection("state-exam-students")
      .where(
        "STUDENT_GROUP_ID",
        "==",
        this.$attrs.selectedClassGroup.STUDENT_GROUP_ID
      )
      .onSnapshot((docs) => {
        this.examStudents = [];
        docs.forEach(async (doc) => {
          let student = doc.data();
          student.id = doc.id;
          student.ref = doc.ref;

          this.examStudents.push(student);
          this.forceRerender();
        });
      });
  },
};
</script>
